const i = t => t == null || t.trim() === "",
  m = t => !i(t);
export { i as isEmpty, m as isNotEmpty };